<div class="row page-head">
  <div class="col-xs-12 offset-sm-3 col-sm-5">
    <table>
      <tr>
        <td rowspan="2" width="83px" height="83px">
          <img [src]="img_src" height="60px" />
        </td>

        <td>
          <span id="header-title" class="profileName">{{ headerTitle }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span id="header-text1" class="profileGrade">{{ headerText1 }}</span>
        </td>
      </tr>
    </table>
  </div>

  <div class="col-xs-12 col-sm-4">
    <div id="general_search" *ngIf="hasEntitlement('SEARCH_VISITOR')">
      <div class="dropdown open" dropdown="">
        <form
          class="input-group"
          (submit)="generalSearchVisitorCards(vcSearchParam)"
          name="searchForm"
        >
          <input
            type="search"
            class="form-control vcSearchParam"
            placeholder="Search card ID/chip account"
            [(ngModel)]="vcSearchParam"
            name="vcSearchParam"
            id="vcSearchParam"
            (click)="showRecent = !showRecent"
          />
          <span id="search_button" class="input-group-btn">
            <button class="btn btn-nc" type="button">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </form>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <ul
            class="dropdown-menu"
            [ngStyle]="{ display: showRecent ? 'block' : 'none' }"
            id="recentSearchesList"
          >
            <li class="recentSearchHeader">RECENT SEARCHES</li>
            <li *ngIf="visitorCardStubs.length > 0">
              <app-visitor-card-search-results
                (visitorCardStubSelected)="selectRecentVisitorCardStub($event)"
                [visitorCardStubs]="visitorCardStubs"
              ></app-visitor-card-search-results>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
